import { type FC } from 'react'
import { useIntl } from 'react-intl'

import {
  ATTRIBUTE_NAME_COLOR_NUMBER,
  ATTRIBUTE_NAME_PACKAGE_SIZE,
} from '../../../product-page-context/ATTRIBUTE_NAME'
import { useProductPageContext } from '../../../productPageContext'

export const ProductBuyBoxStickyProductQuantity: FC = () => {
  const { product } = useProductPageContext()
  const intl = useIntl()

  const attributes: string[] = []
  if (product.variant_attributes) {
    for (const attribute of product.variant_attributes) {
      if (attribute.variant_attribute !== ATTRIBUTE_NAME_PACKAGE_SIZE) {
        const trimmedLabel = attribute.label?.trim() ?? ''
        const label =
          attribute.variant_attribute === ATTRIBUTE_NAME_COLOR_NUMBER
            ? intl.formatMessage({ id: 'variantAttributes.label.color_number' })
            : trimmedLabel
        attributes.push(`${label}: ${attribute.value ?? ''}`)
      }
    }
  }

  attributes.push(
    [product.package_size?.quantity, product.package_size?.unit]
      .filter(Boolean)
      .join(' '),
    product.pharma_form?.label ?? '',
  )

  const productAttributes = attributes.filter(Boolean).join(' | ')

  return (
    <span className="line-clamp-2 min-h-[42px] text-s text-dark-primary-strong">
      {productAttributes}
    </span>
  )
}
